import React, { useState } from "react";
import GeoreferenziazioniHeader from "./Header";
import GeoreferenziazioniTable from "./Table";
import GeoreferenziazioniAddModal from "./AddModal";

const Georeferenziazioni = ({ georeferenziazioni = [], edit, onChange }) => {
  const [showAddModal, setShowAddModal] = useState(false);

  const handleAddGeoreferenziazione = (georeferenziazione) => {
    onChange([...georeferenziazioni, georeferenziazione]);
    setShowAddModal(false);
  };

  const handleDeleteGeoreferenziazione = (georeferenziazione) => {
    const newGeoreferenziazioni = georeferenziazioni.filter((item) => item !== georeferenziazione);
    onChange(newGeoreferenziazioni);
    setShowAddModal(false);
  };

  return (
    <>
      <div className="georeferenziazioni-container">
        <GeoreferenziazioniHeader
          edit={edit}
          onOpenModal={() => setShowAddModal(true)}
        />
        <GeoreferenziazioniTable
          georeferenziazioni={georeferenziazioni}
          handleDeleteGeoreferenziazione={handleDeleteGeoreferenziazione}
          edit={edit}
        />
        {showAddModal && (
          <GeoreferenziazioniAddModal
            show={showAddModal}
            georeferenziazioni={georeferenziazioni}
            handleClose={() => setShowAddModal(false)}
            handleAddGeoreferenziazione={handleAddGeoreferenziazione}
          />
        )}
      </div>
    </>
  );
};

export default Georeferenziazioni;
